import { render, staticRenderFns } from "./TipusBorraDetail.vue?vue&type=template&id=2e1ad0ed&scoped=true"
import script from "./TipusBorraDetail.vue?vue&type=script&lang=js"
export * from "./TipusBorraDetail.vue?vue&type=script&lang=js"
import style0 from "./TipusBorraDetail.vue?vue&type=style&index=0&id=2e1ad0ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1ad0ed",
  null
  
)

export default component.exports